//@vendor
const moment = require('moment');

// @ utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;
const { countActiveFilters, findActiveFilters } = require('utilities/filtersHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const { COMMERCIAL_ADS_CHANNEL } = require('constants/index');
const {
    DATE_FILTER_NONE,
    DATE_FORMAT_API
} = require('constants/index');
const {
    AMAZON_DEFAULT_PAGE_NUMBER,
    AMAZON_DEFAULT_PAGE_SIZE
} = require('constants/accountAmazonGiftCard');
const { success } = require("actions/notifications");

// @actions
const signaturePatternActions = require('actions/signaturePattern');

const reset = () => ({
    type: actionTypes.RESET_AMAZON_COUPON_CODE
});

const resetAmazonReturnCardState = () => ({
    type: actionTypes.AMAZON_GIFT_CARD_RETURN_STATE_RESET
});

const setAmazonConsultType = (value) => ({
    type: actionTypes.AMAZON_SET_CONSULT_TYPE,
    payload: {
        value
    }
});

const getAmazonCouponCodeInfoError = (error) => ({
    type: actionTypes.AMAZON_GET_COUPON_CODE_ERROR,
    payload: {
        error
    }
});

const getAmazonCouponCodeInfoRequest = () => ({
    type: actionTypes.AMAZON_GET_COUPON_CODE_REQUEST
});

const getAmazonCouponCodeInfoSuccess = (response, requestMore) => ({
    type: actionTypes.AMAZON_GET_COUPON_CODE_SUCCESS,
    payload: {
        response,
        requestMore : requestMore
    }
});

const amazonPromotionCardIsFetching = () => ({
    type: actionTypes.AMAZON_GET_PROMOTION_CARD_IS_FETCHING,
})

const amazonPromotionCardSuccess = (response) => ({
    type: actionTypes.AMAZON_GET_PROMOTION_CARD_SUCCESS,
    payload: {
        response
    }
});

const amazonPromotionCardError = (error) => ({
    type: actionTypes.AMAZON_GET_PROMOTION_CARD_ERROR,
    payload: {
        error
    }
});

const amazonPromoCodeIsFetching = (id) => ({
    type: actionTypes.AMAZON_GET_PROMO_CODE_IS_FETCHING,
    payload: {
        id
    }
})

const amazonPromoCodeSuccess = (response, id) => ({
    type: actionTypes.AMAZON_GET_PROMO_CODE_SUCCESS,
    payload: {
        response,
        id
    }
});

const amazonPromoCodeError = (error, id) => ({
    type: actionTypes.AMAZON_GET_PROMO_CODE_ERROR,
    payload: {
        error,
        id
    }
});

const requestNextAmazonCouponCodeInfoPageRequest = (response) => ({
    type: actionTypes.FETCH_NEXT_AMAZON_COUPON_CODE_INFO_PAGE_REQUEST,
    payload: {
        response
    }
});

const getAmazonCouponCodeInfo = () => (dispatch, getState) => {
    const immAmazonGiftCard = getState().amazonGiftCards;
    const immFilters = immAmazonGiftCard.get('filters');
    const requestData = {
        query: {
            pageSize: AMAZON_DEFAULT_PAGE_SIZE,
            pageNumber: AMAZON_DEFAULT_PAGE_NUMBER
        },
        header: {
            version: 2
        }
    }

    if (findActiveFilters(immFilters)) {
        if (immFilters.getIn(['date', 'isActive']) && immFilters.getIn(['date', 'selected']) !== DATE_FILTER_NONE) {
            requestData.query.startDate = moment(immFilters.getIn(['date', 'from'])).format(DATE_FORMAT_API);
            requestData.query.endDate = moment(immFilters.getIn(['date', 'to'])).format(DATE_FORMAT_API);
        }
    }

    dispatch(getAmazonCouponCodeInfoRequest());
    return APIGet({
        dispatch,
        endpoint: 'amazonGiftCouponCodeHistory',
        params: requestData
    })
        .then(response => {
            dispatch(getAmazonCouponCodeInfoSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getAmazonCouponCodeInfoError(response.error));
            } else {
                throw response;
            }
        });
};

const getAmazonPromotionCard = (id) => (dispatch) => {
    dispatch(amazonPromotionCardIsFetching());

    const params = {
        query: {
            channel: COMMERCIAL_ADS_CHANNEL,
            lang: getLanguage().toLowerCase(),
            locations: id
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'requestAds',
        params
    })
        .then(response => {
            dispatch(amazonPromotionCardSuccess(response.nodes));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(amazonPromotionCardError(response.error));
            } else {
                throw response;
            }
        });
};

const setAmazonPromoCode = (amount, requestId, id) => (dispatch) => {
    dispatch(amazonPromoCodeIsFetching(id));

    const params = {
        query: {
            amount: amount,
            requestId: requestId
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'requestAmazonPromoCode',
        params
    })
        .then(response => {
            dispatch(amazonPromoCodeSuccess(response.giftCardClaimCode, id));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(amazonPromoCodeError(response.error, id));
            } else {
                throw response;
            }
        });
};

const showNotification = message => dispatch => {
    dispatch(success({
        message
    })); 
};

const setAmazonGiftCardsFilter = filters => dispatch => {
    dispatch({
        type: actionTypes.AMAZON_GIFT_CARD_SET_FILTERS, // tagged for analytics
        payload: {
            filters
        }
    });
};

const clearAmazonGiftCardsFilter = () => (dispatch) => {
    dispatch({
        type: actionTypes.AMAZON_GIFT_CARD_CLEAR_FILTERS // tagged for analytics
    });
};

const resetAmazonGiftCardsFilter = (filter) => (dispatch, getState) => {
    const immFilters = getState().amazonGiftCards.get('filters');

    if (countActiveFilters(immFilters) === 1) {
        dispatch(clearAmazonGiftCardsFilter());
    } else {
        dispatch({
            type: actionTypes.AMAZON_GIFT_CARD_RESET_FILTER,
            payload: {
                filterKey: filter
            }
        });
    }
}

const requestNextAmazonCouponCodeInfoPage = () => (dispatch, getState) => {
    const nextPageURL = getState().amazonGiftCards.get('nextPage');
    const params = {
        header: {
            version: 2
        }
    }

    dispatch(requestNextAmazonCouponCodeInfoPageRequest());
    return APIGet(dispatch, nextPageURL, params)
        .then(response => dispatch(getAmazonCouponCodeInfoSuccess(response, true)))
        .catch(error => dispatch(getAmazonCouponCodeInfoError(error)));
};

const returnAmazonGiftCardRequest = () => ({
    type: actionTypes.AMAZON_GIFT_CARD_RETURN_REQUEST
})

const returnAmazonGiftCardSuccess = (response) => ({
    type: actionTypes.AMAZON_GIFT_CARD_RETURN_SUCCESS,
    payload: {
        response
    }
});

const returnAmazonGiftCardFailure = (error) => ({
    type:  actionTypes.AMAZON_GIFT_CARD_RETURN_FAILURE,
    payload: {
        error
    }
});

const returnAmazonGiftCard = (amount, requestId, contratoOrdenanteIban) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const emailId = PersonalDataHelper.getEmail(getState().profile);

        const requestData = {
            query: {
                amount,
                contratoOrdenanteIban,
                dataToken,
                emailId,
                requestId,
            }
        }

        dispatch(returnAmazonGiftCardRequest());

        return APIPost({
            dispatch,
            endpoint: 'cancelAmazonGiftCard',
            params: requestData
        })
        .then(response => {
            dispatch(returnAmazonGiftCardSuccess(response));
        })
        .catch(response => {
            dispatch(returnAmazonGiftCardFailure(response.error));
        });
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

const sendAmazonGiftCardReturnDetails = (giftCardDetails) => ({
    type: actionTypes.SEND_AMAZON_GIFT_CARD_RETURN_DETAILS,
    payload: {
        giftCardDetails
    }
});

module.exports = {
    clearAmazonGiftCardsFilter,
    getAmazonCouponCodeInfo,
    getAmazonPromotionCard,
    requestNextAmazonCouponCodeInfoPage,
    reset,
    resetAmazonGiftCardsFilter,
    resetAmazonReturnCardState,
    returnAmazonGiftCard,
    sendAmazonGiftCardReturnDetails,
    setAmazonConsultType,
    setAmazonGiftCardsFilter,
    setAmazonPromoCode,
    showNotification,
};
